<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :max-width="$vuetify.breakpoint.lgAndUp ? '32%' : '500px'"
    :retain-focus="false"
    :transition="
      $vuetify.breakpoint.xs ? 'dialog-bottom-transition' : 'dialog-transition'
    "
    class="custom-dialog"
    content-class="custom-dialog-card"
  >
    <v-card class="custom-dialog-card">
      <v-card-title class="justify-space-between flex-nowrap">
        <div class="one-line-truncation confirmationDialogTitle">
          {{ cardTitle }}
        </div>
        <div>
          <v-btn icon small @click="hideDialog()">
            <v-icon size="16" color="primary-purple">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pt-5">
        <div class="mb-3">
          <slot name="cardText"></slot>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text class="custom-cancel-btn" @click="hideDialog()"
          >Cancel</v-btn
        >
        <v-btn
          depressed
          color="primary"
          class="custom-save-btn text-white rounded-pill"
          :loading="actionLoader"
          @click="sendEmitToParentForConfirm"
        >
          {{ cardActionTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: [
    "cardTitle",
    "cardText",
    "cardActionTitle",
    "actionLoader",
    "cardActionColor",
  ],
  data() {
    return {
      dialog: true,
    };
  },
  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.hideDialog();
      }
    },
  },
  methods: {
    hideDialog() {
      this.$emit("closeConfirmationDialog");
    },

    sendEmitToParentForConfirm() {
      this.$emit("confirmation");
    },
  },
};
</script>

<style>
.confirmationDialogTitle {
  max-width: 90% !important;
}
</style>
